module.exports = __webpack_public_path__ + "media/images/NCPC-logo-da9757e95a461db852e15d9ab5b20afb.gif";